import React from "react";
import { useTranslation } from "react-i18next";

const About = () => {
    const { t, i18n } = useTranslation();
    console.log("i18n.language =", i18n.language);
    console.log("about.title =", t("about.title"));

    return (
        <div className="home-container page-content" style={{ color: "black", textAlign: "center" }}>
            <div className="about-container">
                <h1 className="about-title">{t("about.title")}</h1>
                <h3 className="about-description">
                    {t("about.description")}
                </h3>
            </div>
        </div>
    );
};

export default About;
